document.documentElement.classList.remove('no-js');
function closeMenus(header) {
  header.querySelectorAll('[data-menu-dropdown][open]').forEach(menu => { menu.open = false; });
}
document.addEventListener('click', event => {
  const toggle = event.target.closest('[data-mobile-toggle]');
  if (toggle) {
    const header = toggle.closest('[data-gallery-header]');
    const nav = header.querySelector('[data-main-nav]');
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    if (!open) closeMenus(header);
    return;
  }
  document.querySelectorAll('[data-gallery-header]').forEach(header => {
    if (!header.contains(event.target)) closeMenus(header);
  });
});
document.addEventListener('toggle', event => {
  const menu = event.target;
  if (!menu.matches('[data-menu-dropdown]') || !menu.open) return;
  const siblings = menu.parentElement.parentElement.querySelectorAll(':scope > .menu-item > [data-menu-dropdown]');
  siblings.forEach(sibling => { if (sibling !== menu) sibling.open = false; });
}, true);
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const header = event.target.closest('[data-gallery-header]');
  if (!header) return;
  const menu = event.target.closest('[data-menu-dropdown][open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  } else {
    closeMenus(header);
    header.querySelector('[data-main-nav]').classList.remove('is-open');
    const toggle = header.querySelector('[data-mobile-toggle]');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    if (window.matchMedia('(max-width: 900px)').matches) toggle.focus();
  }
});

// Reveal a selected product information panel in the theme editor.
document.addEventListener('shopify:block:select', event => {
  const panel = event.target.matches('details') ? event.target : event.target.querySelector('details');
  if (panel && panel.id.startsWith('ProductInformation-')) panel.open = true;
});

function revealArtworkInquiryFeedback(root = document) {
  root.querySelectorAll('.product-inquiry-form').forEach(panel => {
    if (panel.querySelector('[role="status"], [role="alert"]')) panel.open = true;
  });
}
revealArtworkInquiryFeedback();
document.addEventListener('shopify:section:load', event => revealArtworkInquiryFeedback(event.target));
